import { type IDropdownItem } from 'shared/ui'
import { EnumUserRoles } from 'entities/Users/model/types'

export const roleLabelsMap: Record<EnumUserRoles, string> = {
  [EnumUserRoles.OWNER]: 'Owner',
  [EnumUserRoles.ADMIN]: 'Admin',
  [EnumUserRoles.MANAGER]: 'Manager',
  [EnumUserRoles.MEMBER]: 'Member',
  [EnumUserRoles.VIEW_ONLY]: 'Observer',
}

export const roleDropdownItems: IDropdownItem[] = [
  {
    id: EnumUserRoles.ADMIN,
    value: EnumUserRoles.ADMIN,
    label: 'Admin',
  },
  {
    id: EnumUserRoles.MANAGER,
    value: EnumUserRoles.MANAGER,
    label: 'Manager',
  },
  {
    id: EnumUserRoles.MEMBER,
    value: EnumUserRoles.MEMBER,
    label: 'Member',
  },
  {
    id: EnumUserRoles.VIEW_ONLY,
    value: EnumUserRoles.VIEW_ONLY,
    label: 'Observer',
  },
]
